/**
 * Texts for Press Releases page
 */
export const pressReleasesPageText = {
    title: 'Comunicati stampa - CamAPS FX',
    titleMeta: 'Comunicati stampa - CamAPS FX',
    descriptionMeta: 'Ultimi comunicati stampa e notizie da CamAPS FX.',
    keywords: 'comunicati stampa camaps, notizie camaps, notizie tecnologia diabete',
    localeMeta: 'it_it',

    bannerTitle: 'Comunicati stampa',
    bannerSubtitle: 'Resta aggiornato con i nostri ultimi annunci',

    contactText: 'Per qualsiasi richiesta stampa, contattare via <a href="mailto:media@camdiab.com">media@camdiab.com</a>',
    pressReleasesDisclaimer: 'Tutti i comunicati stampa sono pubblicati in inglese.',

    download: 'Scarica',
    showMore: 'Mostra di più',
    showLess: 'Mostra meno',
};

